import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Badge } from "@/components/ui/badge";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

const TYPES = { additional_work: "عمل إضافي", parts: "قطع غيار" };
const ST = {
  pending: { t: "بانتظار العميل", c: "bg-amber-500/10 text-amber-600 border-amber-500/20" },
  accepted: { t: "مقبول", c: "bg-emerald-500/10 text-emerald-600 border-emerald-500/20" },
  rejected: { t: "مرفوض", c: "bg-destructive/10 text-destructive border-destructive/20" },
};

export default function PriceItems({ requestId, role, onChange }) {
  const [items, setItems] = useState([]);
  const [f, setF] = useState({ type: "additional_work", description: "", amount: "", notes: "" });

  const load = async () => {
    try { const { data } = await api.get(`/requests/${requestId}/price-items`); setItems(data); } catch {}
  };
  useEffect(() => { load(); const t = setInterval(load, 6000); return () => clearInterval(t); }, [requestId]);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/requests/${requestId}/price-items`, { ...f, amount: Number(f.amount || 0) });
      toast.success("تم إرسال التسعير للعميل للموافقة");
      setF({ type: "additional_work", description: "", amount: "", notes: "" });
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const respond = async (id, action) => {
    try { await api.post(`/price-items/${id}/respond`, { action }); toast.success(action === "accept" ? "تم القبول" : "تم الرفض"); load(); onChange?.(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="space-y-3" data-testid="price-items">
      {role === "workshop" && (
        <form onSubmit={add} className="space-y-2 border border-border rounded-xl p-3">
          <Select value={f.type} onValueChange={(v) => setF({ ...f, type: v })} dir="rtl">
            <SelectTrigger data-testid="pi-type"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="additional_work">عمل إضافي</SelectItem>
              <SelectItem value="parts">قطع غيار</SelectItem>
            </SelectContent>
          </Select>
          <Input value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} placeholder="الوصف" required data-testid="pi-desc" />
          <Input type="number" value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} placeholder="المبلغ (ر.س)" required data-testid="pi-amount" />
          <Textarea value={f.notes} onChange={(e) => setF({ ...f, notes: e.target.value })} placeholder="ملاحظات (اختياري)" data-testid="pi-notes" />
          <Button type="submit" className="w-full rounded-xl" data-testid="pi-submit">إرسال للعميل للموافقة</Button>
        </form>
      )}
      {items.length === 0 ? (
        <div className="text-xs text-muted-foreground text-center py-3">لا توجد بنود تسعير إضافية</div>
      ) : items.map((it) => (
        <div key={it.id} className="border border-border rounded-xl p-3" data-testid={`pi-${it.id}`}>
          <div className="flex items-center justify-between mb-1">
            <span className="font-semibold text-sm">{TYPES[it.type]}</span>
            <Badge variant="outline" className={ST[it.status].c}>{ST[it.status].t}</Badge>
          </div>
          <div className="text-sm">{it.description} — <span className="font-bold text-primary">{it.amount} ر.س</span></div>
          {it.notes && <div className="text-xs text-muted-foreground mt-1">{it.notes}</div>}
          {role === "customer" && it.status === "pending" && (
            <div className="flex gap-2 mt-2">
              <Button size="sm" className="rounded-lg bg-emerald-600 hover:bg-emerald-700" onClick={() => respond(it.id, "accept")} data-testid={`pi-accept-${it.id}`}>قبول</Button>
              <Button size="sm" variant="outline" className="rounded-lg text-destructive border-destructive/30" onClick={() => respond(it.id, "reject")} data-testid={`pi-reject-${it.id}`}>رفض</Button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
